import type { Testimonio } from '../types/content'

export const testimonios: Testimonio[] = [
  {
    texto:
      'Compré el MegaPack un jueves a la noche. El viernes llegué con todo organizado: precios, diseños listos, protocolo de clientas. Mis ganancias aumentaron en la primera semana.',
    iniciales: 'MV',
    nombre: 'Mariana V.',
    ciudad: 'Buenos Aires, Argentina',
    rol: 'Manicurista independiente',
  },
  {
    texto:
      'Trabajaba 10 horas por poco dinero. Con el Tomo 4 entendí mis costos reales y subí precios. Al mes siguiente ganaba el doble haciendo lo mismo.',
    iniciales: 'FL',
    nombre: 'Fernanda L.',
    ciudad: 'Ciudad de México, México',
    rol: 'Técnica de uñas',
  },
  {
    texto:
      'Tenía empleadas estresadas y clientas enojadas. Implementé los protocolos del Tomo 3 y el Tomo 6: bajó la rotación, subieron las ganancias y el equipo está más tranquilo.',
    iniciales: 'VP',
    nombre: 'Valentina P.',
    ciudad: 'Bogotá, Colombia',
    rol: 'Dueña de estética',
  },
  {
    texto:
      'Lo que más me cambió fue el Tomo 2. Tengo los diseños listos, los muestro en WhatsApp y ya no pierdo dos horas por clienta pensando qué hacer.',
    iniciales: 'LR',
    nombre: 'Luisa R.',
    ciudad: 'Lima, Perú',
    rol: 'Técnica de uñas',
  },
  {
    texto:
      'La Guía Visual de Formas me hizo parecer experta. Mis clientas confían más en mis recomendaciones y cobro más porque asesoro además de hacer la manicura.',
    iniciales: 'BM',
    nombre: 'Bárbara M.',
    ciudad: 'Santiago, Chile',
    rol: 'Manicurista independiente',
  },
  {
    texto:
      'Tenía clientas que me pedían extras sin pagar y me hacían quedar después de hora. Con el Escudo Anti-Reclamos puse límites: gané paz mental y dinero real.',
    iniciales: 'DG',
    nombre: 'Daniela G.',
    ciudad: 'Rosario, Argentina',
    rol: 'Dueña de estética',
  },
]
